module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/assinante/assinante.component.css
// module id = ./src/app/assinante/assinante.component.css
// module chunks = main